<template>
    <VJoyHighlight
        class="portfolio-experience-link-highlight"
        data-testid="portfolio-experience-link-highlight"
        display-icon
        icon="info-circle"
        level="info"
    >
        <div class="portfolio-experience-link-highlight__content">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <p class="portfolio-experience-link-highlight__text" v-html="t('profile.section.portfolio.experience.link.highlight')" />
            <a
                :href="t('profile.section.portfolio.experience.link.highlight.url')"
                class="portfolio-experience-link-highlight__link"
                data-testid="portfolio-experience-link-highlight-learn-more"
                rel="noopener noreferrer"
                target="_blank"
            >
                {{ t('generic.knowmore.aria.label') }}
            </a>
        </div>
    </VJoyHighlight>
</template>

<script setup lang="ts">
    import {useTranslation} from '#imports';
    import {VJoyHighlight} from '@maltjoy/core-vue';

    const {t} = useTranslation();
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .portfolio-experience-link-highlight {
        &__content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: var(--joy-core-spacing-2);
        }

        &__text {
            margin: 0;

            :deep(strong) {
                font-weight: var(--joy-font-weight-bold);
            }
        }

        &__link {
            flex-shrink: 0;
            font-weight: var(--joy-font-weight-bold);
            white-space: nowrap;
        }

        @include mq.screen_xs {
            &__content {
                flex-wrap: wrap;
            }

            &__link {
                white-space: normal;
            }
        }
    }
</style>
